let BaseUrl =  getdomain() ;
let gloabUrl = getdomain() ;
function getdomain() {
	let url = window.location.origin
    if(process.env.NODE_ENV == "development"){	
		return 'https://egret.service.qifanonline.com/';
	}else if( process.env.NODE_ENV !== "development"  && url == 'https://egret.qifanonline.com'){
		return 'https://egret.service.qifanonline.com/';		
	}else {
		let h = url.replace(/portal/, "service")
		return `${h}/`		
	}

}
export default
  {    
    gloabUrl,//接口api公共地址
    BaseUrl
  }


// WEBPACK FOOTER //
// ./src/components/common/resouces/config.js